import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../../shared/abstract-boxes';
import { getImageMapConfigurationOption } from './imageMap-Configuration';

export const ALWAYS_LAST_ANSWER_TYPES = ['user-input', 'next-box-by-default'];

export function ImageMapBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'imageMapEditImageController',
    editElementModalTemplate: require('./imageMap-EditImage.modal.html'),
    angularTemplate: require('./imageMap-Box.view.html'),

    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
    },

    getText: function () {
      return this.angularScope.elementData ? this.angularScope.elementData.altText : null;
    },

    /**
     * Adds a new zone within an exisiting zone group
     * We loop on all children and we unembed all children
     * starting from the 'add zone' item that has the given imagemapElementId,
     * then we insert a new zone,
     * then we re-embed all unembeded children.
     */
    addChildClicked: function (buttonId, imagemapElementId) {
      let unembeded = [];
      let unembedding = false;
      let getEmbeddedCells = this.model.getEmbeddedCells();

      for (let child of getEmbeddedCells) {
        if (child.get('addChildId') === imagemapElementId && child.get('type') === 'html.ImageMapAddZoneButton') {
          unembedding = true;
        }
        if (unembedding) {
          this.model.unembed(child);
          unembeded.push(child);
        }
      }

      this.addImageMapZone(buttonId, imagemapElementId);
      unembeded.forEach((child) => this.model.embed(child));
      this.resizeBox();
    },

    /**
     * Add a button "addZone"
     * excuted in create-custom-jointjs-elements, not by a user action
     */
    addImageMapAddZoneButton: function (imagemapElementId) {
      let button = this.createImageMapAddZoneButton(null, imagemapElementId);
      this.model.graph.addCell(button);
      this.model.embed(button);
    },

    /**
     * Create the content of the button "addZone"
     */
    createImageMapAddZoneButton: function (
      id,
      imagemapElementId,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = null
    ) {
      if (!elementData) {
        elementData = {
          imagemapElementId: imagemapElementId
        };
      }
      let button = new joint.shapes.html.ImageMapAddZoneButton({ id, position, size, elementData });

      return button;
    },

    /**
     * Add an element "Zone"
     * excuted by a user action
     */
    addImageMapZone: function (id) {
      let zone = this.createImageMapZone(id);
      this.model.embed(zone);
      this.model.graph.addCell(zone);
      // open the new zone immediately
      this.paper.findViewByModel(zone).editElement();
    },

    /**
     * Create the content of the element "Zone"
     */
    createImageMapZone: function (id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE, elementData = null) {
      if (!elementData) {
        elementData = { type: 'text', newBox: true };
      }
      let zone = new joint.shapes.html.ImageMapZone({ id, position, size, elementData });

      return zone;
    },

    /**
     * Get the image url from its id stored in elementData
     */
    getPictureUrl: function () {
      if (this.angularScope.elementData) {
        return this.angularScope.elementData.url + '/240';
      }
      return '';
    },

    /**
     * Read in configuration file
     * @param key name of the property
     */
    getConfigurationOption: function (key) {
      return getImageMapConfigurationOption(key);
    }
  });
}
